import React, { useState } from 'react';
import { Modal, Box, ButtonGroup, Button, Divider, Paper, Typography } from '@mui/material';
import { toast } from 'react-toastify';

export default function AdminAppDeleteSimDataModal({ onTriggerDelete }) {

    const [open, setOpen] = useState(false);
    
    const handleClose = () => setOpen(false);

    const title = `Delete Simulator Data`;

    const handleConfirmDeleteSimData = async () => {
        setOpen(true);
    };

    const handleDeleteSimData = async () => {
        const recordsDeleted = await deleteSimCreatedData();
        onTriggerDelete(recordsDeleted);
    }
    
    const deleteSimCreatedData = async () => {
        try {            
            const response = await fetch(`${process.env.REACT_APP_API}/applications/simulatorCreated`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
            });

            if (!response.ok) {
                toast.error(`HTTP error! status: ${response.status}`);
            } else {
                const json = await response.json();
                if (json.message === 'success') {
                    handleClose();
                    return true;
                } else {
                    toast.warning(json.message);
                    handleClose();
                }
            }
            return false;
        } catch (error) {
            toast.error(error);
        } 
    }

    return (
        <>
            <Button variant="contained" color="error" sx={{ mt: 2 }} onClick={handleConfirmDeleteSimData}>
                Delete Sim Records
            </Button>
    
            <Modal 
                open={open} 
                onClose={handleClose}
                style={{
                    overlay: {
                    backgroundColor: '#080030', // Semi-transparent black
                    },
                    content: {
                    backgroundColor: '#080030',
                    },
                }}
            >
               
                <Box sx={{color: 'white', p: 4}}>
                    <Box
                    component={Paper}
                    elevation={3}
                    sx={{
                        mx: 'auto',
                        width: 400,
                        bgcolor: '#1e1e1e',
                        p: 2,
                    }}
                >
                        <Typography variant="h4" component="h2" color="white">
                            {title}
                        </Typography>

                        <Divider sx={{ width:'100%', color:'grey', borderTop: 1, mt: 1, mb:2 }} />

                        <Box component="form" sx={{ color: 'white'}}>
                            <Typography>
                                Are you sure you would like to delete this Application ?
                                <br /><br />
                                This action can not be undone!
                            </Typography>
                            
                            <Divider sx={{ width:'100%', color:'grey', borderTop: 1, mt:4 }} />
                            <ButtonGroup 
                                size="small"
                                variant="contained" 
                                aria-label="Basic button group" 
                                fullWidth
                                sx={{ mt:2 }}
                            >
                        
                                <Button
                                    onClick={handleClose}
                                    variant="contained"
                                    sx={{
                                        bgcolor: '#303F9F',
                                        textTransform: 'none',
                                        alignSelf: 'flex-start',
                                        mt: 1,
                                        '&:hover': {
                                        bgcolor: '#303F9F',
                                        },
                                        '&:disabled': {
                                        bgcolor: 'rgba(255, 255, 255, 0.12)',
                                        },
                                    }}
                                >
                                    {'Cancel '}
                                </Button>

                                <Button
                                    onClick={() => handleDeleteSimData()}
                                    variant="contained"
                                    sx={{
                                        bgcolor: '#303F9F',
                                        textTransform: 'none',
                                        alignSelf: 'flex-start',
                                        mt: 1,
                                        ml: 5,
                                        '&:hover': {
                                        bgcolor: '#303F9F',
                                        },
                                        '&:disabled': {
                                        bgcolor: 'rgba(255, 255, 255, 0.12)',
                                        },
                                    }}
                                >
                                    {'Delete Sim Data'}
                                </Button>
                            </ButtonGroup>
                        </Box>
                    </Box>
                </Box>                
            </Modal>            
        </>
    );
}
